export default __webpack_public_path__ + "static/media/logo-white.a8b12ee7.svg";